import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { EntitiesContext, UserContext } from '../../App';
import { useDeleteInventory } from '../../hooks/useInventory';
import { useGetSaleOrders } from '../../hooks/useSale';
import { useGetAccountOrders } from '../../hooks/useAccount';
import ConsignorTotals from './ConsignorTotals';

export default function Inventory({ sale, items }) {
  const navigate = useNavigate();
  const entities = useContext(EntitiesContext);
  const user = useContext(UserContext);
  const lists = entities.state.get('list');

  const deleteInventory = useDeleteInventory();
  const orders = useGetAccountOrders(user.user);

  const showListItem = item => {
    if (item) return lists.get(parseInt(item)).label;

    return '';
  }

  const remove = item => {
    deleteInventory.mutate(item);
  }

  const edit = item => {
    navigate(`/dashboard/inventory/${item.id}`);
  }

  const hasPaidOrder = inventory => {
    return entities.state.get('order').get(inventory.order_id)?.status.toLowerCase() === 'paid';
  }

  if (orders.isLoading) return <div>loading</div>

  return (
    <>
      <ConsignorTotals items={items} />
      <table className="table is-fullwidth">
      <thead>
        <tr>
          <th>Name</th>
          <th>Price</th>
          <th>Condition</th>
          <th>Category</th>
          <th>Clothing Type</th>
          <th>Size</th>
          <th>Boot Size</th>
          <th>Length</th>
          <th>Skate Size</th>
          <th>Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {items.count() < 1  && <tr>
          <td className="has-text-centered" colSpan="11">
            No items found, <Link to="/dashboard/inventory/add">go add some</Link>
          </td>
        </tr>}
        {items.valueSeq().map(i => <tr key={i.id}>
          <td>{i.name}</td>
          <td>${i.price} {i.donate && <span>(donation)</span>}</td>
          <td>{showListItem(i.condition)}</td>
          <td>{showListItem(i.category)}</td>
          <td>{showListItem(i.clothing_type)}</td>
          <td>{showListItem(i.category) === 'Kids Clothing' ? showListItem(i.kids_size) : showListItem(i.size)}</td>
          <td>{showListItem(i.boot_size)}</td>
          <td>{i.length}</td>
          <td>{i.skate_size}</td>
          <td>{hasPaidOrder(i) ? 'sold' : 'available'}</td>
          {sale && !sale.consignment_closed ? <td><a onClick={() => edit(i)}>edit</a> | <a onClick={() => remove(i)}>delete</a></td> : <td></td>}
        </tr>)}
      </tbody>
      </table>
    </>
  );
}
